var version = 'local';

export { version };
//# sourceMappingURL=version.js.map
